import { render, staticRenderFns } from "./product9.vue?vue&type=template&id=ac0df70c&scoped=true"
import script from "./product9.vue?vue&type=script&lang=js"
export * from "./product9.vue?vue&type=script&lang=js"
import style0 from "./product9.vue?vue&type=style&index=0&id=ac0df70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0df70c",
  null
  
)

export default component.exports